<input type="file" #excelFileImportInput ng2FileSelect [uploader]="fileUploader" hidden/>
<a color="primary"
  style="cursor: pointer;"
  (click)="excelFileImportInput.value = ''; excelFileImportInput.click()">
  <ng-template *ngTemplateOutlet="buttonContentTemplate"></ng-template>
</a>
